import { connect } from 'react-redux'

import {
  setDriver,
  claimsDriversLicenseAdd,
  claimsDriversLicenseRemove,
  clearDriverLicenseFile,
} from '../actions'

import AddDriver from './AddDriver'

const mapDispatchToProps = {
  setDriver,
  claimsDriversLicenseAdd,
  claimsDriversLicenseRemove,
  clearDriverLicenseFile,
}

const mapStateToProps = state => {
  return {
    driver: state.drivers.driver,
    driversLicenseFile: state.drivers.driversLicenseFile,
    deleteDriverLicenseResponse: state.drivers.deleteDriverLicenseResponse,
    isWidgetState: state.appReducer.isWidget,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDriver)
